export default __webpack_public_path__ + "static/media/couple@3x.765f1e43.png";